var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgBusinessman = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 3.2C13.1222 3.2 11.1526 5.52288 11.6252 8.36256L12.344 12.6646C12.6275 14.3709 14.271 15.7626 16.0003 15.7626C17.7296 15.7626 19.3731 14.3709 19.6566 12.6646L20.3753 8.36256C20.847 5.52288 18.8784 3.2 16.0003 3.2ZM18.2713 8.01344L17.5526 12.3133C17.44 12.9904 16.6857 13.6288 16.0003 13.6288C15.3148 13.6288 14.5606 12.9904 14.448 12.3146L13.7292 8.0112C13.6054 7.26848 13.7667 6.5872 14.1836 6.09568C14.6003 5.60416 15.2448 5.33312 16.0003 5.33312C16.7558 5.33312 17.4003 5.60416 17.816 6.09568C18.2336 6.58752 18.3948 7.2688 18.2713 8.01344Z",
    fill: "#181818"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9793 17.7495L20.1095 16.1233C19.0292 17.2036 17.5617 17.8964 16.0001 17.8964C14.4397 17.8964 12.9709 17.2036 11.8916 16.1233L7.02086 17.7495C6.09382 18.0577 5.3335 19.1098 5.3335 20.089V28.8004H26.6666V20.0887C26.6666 19.1098 25.9073 18.0577 24.9793 17.7495ZM7.46662 26.6669V20.0887C7.48134 20.0033 7.61798 19.8138 7.71046 19.7668L11.4356 18.5242C12.3463 19.1751 13.3745 19.6116 14.4356 19.8397L14.9338 21.3335L13.8669 26.6666H7.46662V26.6669ZM24.5335 26.6669H18.1335L17.0666 21.3338L17.5649 19.8401C18.626 19.6119 19.6541 19.1754 20.5649 18.5245L24.3034 19.7732C24.3825 19.8138 24.5201 20.0036 24.5348 20.1066L24.5335 26.6669Z",
    fill: "#181818"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBusinessman, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Businessman.c94b097c.svg";
export { ForwardRef as ReactComponent };